var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1139 2L14.0419 2.448C13.8059 3.452 14.2759 4.387 15.6369 5.362C18.8129 7.636 19.5629 8.918 18.6599 11.752C18.1279 13.422 18.7729 14.032 20.9999 14.032V16C17.5799 16 15.7729 14.29 16.7719 11.158C17.3549 9.33 17.0399 8.793 14.4789 6.958C12.5229 5.558 11.6729 3.868 12.1139 2Z",
    fill: "#2E2F30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.156 10.32C2.86376 11.8551 2.97625 13.4398 3.48238 14.9182C3.98851 16.3966 4.87086 17.7177 6.04258 18.7516C7.2143 19.7855 8.63503 20.4965 10.1649 20.8146C11.6949 21.1328 13.2813 21.0471 14.768 20.566C14.215 19.288 13.612 19.002 12.488 19.034C12.351 19.037 12.234 19.044 11.978 19.059C10.04 19.176 9.076 18.934 8.165 17.549C7.146 16.003 7.465 14.885 8.695 13.467L8.841 13.299C9.757 12.249 9.844 11.921 9.179 10.965C8.435 9.895 8.022 9.838 6.468 10.283C5.008 10.7 4.072 10.792 3.156 10.32ZM3.774 8.342C4.276 8.725 4.722 8.702 5.918 8.36C8.201 7.707 9.472 7.884 10.821 9.823C12.129 11.703 11.797 12.953 10.348 14.614L10.206 14.777C9.496 15.597 9.428 15.832 9.836 16.45C10.234 17.056 10.57 17.14 11.857 17.063C12.135 17.046 12.266 17.039 12.431 17.034C14.345 16.98 15.661 17.694 16.585 19.746C17.8031 19.0241 18.8336 18.025 19.593 16.8299C20.3523 15.6348 20.8189 14.2774 20.9549 12.868C21.0909 11.4587 20.8924 10.0371 20.3757 8.71883C19.8589 7.40058 19.0384 6.22286 17.9809 5.28137C16.9233 4.33989 15.6585 3.66121 14.2893 3.30049C12.9201 2.93978 11.4851 2.9072 10.101 3.20542C8.71681 3.50363 7.42254 4.12422 6.32334 5.01675C5.22415 5.90927 4.35105 7.04856 3.775 8.342H3.774ZM12 23C5.925 23 1 18.075 1 12C1 5.925 5.925 1 12 1C18.075 1 23 5.925 23 12C23 18.075 18.075 23 12 23Z",
    fill: "#2E2F30"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLang);
export default __webpack_public_path__ + "static/media/icon-lang.29bb085e3550ca346ad0cf0d2fdef39c.svg";
export { ForwardRef as ReactComponent };